export class Schema {
    constructor(name, traits) {
        this.name = name;
        this.traits = traits;
    }
}
